import React from 'react'
import {Link} from "react-router-dom";
import appLogo from "../images/sd-logo.svg";

const LogoWrapper = () => {
    return (
        <aside className="sidebar-icon">
            <div className="logo">
                <Link to={'/'}>
                    <img src={appLogo} alt="GAI Logo"/>
                    {/* <p className={style.logoLineParent}><GAI className={style.logoLine}></GAI></p> */}
                </Link>
            </div>
        </aside>
    )
}

export default LogoWrapper
